import React, { useState, useEffect } from 'react';
import { Card, CardBody, Container, Spinner } from 'reactstrap';
import CardHeaderSpan from '../../../Utils/CommonComponents/CardHeaderSpan';
import CustomTabWebView from '../../ProfileTabs/CustomTabWebView';
import {
  CustomTabItem,
  getProfileValues,
  replacePlaceholders,
  normalizeUrl,
} from '../../../sharedFunctions/customTabs';

interface Props {
  title: string;
  url: string;
}

export default function ManagementWebViewPage({ title, url }: Props) {
  const [activeTab, setActiveTab] = useState<CustomTabItem | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let isMounted = true;
    const prepareTab = async () => {
      try {
        setLoading(true);
        const values = await getProfileValues();
        if (values.serverurl) {
          values.serverurl = String(values.serverurl).replace(/\/+$/, '');
        }
        if (values.baseurl) {
          values.baseurl = String(values.baseurl).replace(/\/+$/, '');
        }
        const replacedUrl = replacePlaceholders(url, values);
        const finalUrl = normalizeUrl(replacedUrl);

        if (isMounted) {
          setActiveTab({
            id: title.toLowerCase().replace(/\s+/g, '_'),
            name: title,
            order: 1,
            type: 'webview',
            url: finalUrl,
            rawUrl: replacedUrl,
            source: 'custom',
          });
        }
      } catch (e) {
        console.error('Error preparing management webview tab:', e);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    prepareTab();

    return () => {
      isMounted = false;
    };
  }, [title, url]);

  return (
    <div className="page-body p-2">
      <Container fluid>
        <Card>
          <CardHeaderSpan headingClassName="py-2 px-3" back={false} heading={title} span="Dashboard" />
          <CardBody className="pt-0">
            {loading || !activeTab ? (
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                <div className="text-center">
                  <Spinner color="primary" />
                  <p className="mt-2 text-muted small">Loading {title}...</p>
                </div>
              </div>
            ) : (
              <CustomTabWebView activeTab={activeTab} />
            )}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
}
